import React from 'react';
import { useTranslation } from 'react-i18next';
import DesktopMenu from './desktop';
import MobileMenu from './mobile';

const Menu = ({ isOpen, onClose, onOpenMenu }) => {
  const { t, i18n } = useTranslation();

  const currentLang = i18n.language || 'tr';

  const ROUTES = [
    {
      key: 'home',
      tr: '/',
      en: '/',
      route: t('routes.home'),
      title: t('home'),
    },
    {
      key: 'about',
      tr: '/hakkimizda',
      en: '/en/about',
      route: t('routes.about'),
      title: t('about'),
    },
    {
      key: 'companies',
      tr: '/sirketlerimiz',
      en: '/our-companies',
      route: t('routes.companies'),
      title: t('companies'),
    },
    {
      key: 'career',
      tr: '/ngaming-hayat',
      en: '/career',
      route: t('routes.career'),
      title: t('career'),
    },
    {
      key: 'contact',
      tr: '/iletisim',
      en: '/contact',
      route: t('routes.contact'),
      title: t('contact'),
    },
    {
      key: 'cookie',
      tr: '/cerez-politikasi',
      en: '/cookie-policy',
      route: t('routes.cookiePolicy'),
      title: t('cookiePolicy'),
    },
    {
      key: 'kvkk',
      tr: '/kisisel-verileri-koruma',
      en: '/personel-data-protection-gdpr',
      route: t('routes.gdpr'),
      title: t('privacyPolicy'),
    },
  ];

  const excludeLinks = ['cookie', 'kvkk'];

  const filteredLinks = ROUTES.filter((item) => !excludeLinks.includes(item.key));

  const switchLanguage = (lang, i18n, pathname, navigate) => {
    const currentPath = pathname;

    const matchedRoute = ROUTES.find(
      (route) => route.tr === currentPath || route.en === currentPath
    );

    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);

    if (matchedRoute && matchedRoute[lang]) {
      navigate(matchedRoute[lang], { replace: true });
      return;
    }

    navigate(currentPath, { replace: true });
  };

  const isActiveRoute = (item, pathname) => {
    return item.tr === pathname || item.en === pathname;
  };

  return (
    <>
      <DesktopMenu
        isActiveRoute={isActiveRoute}
        switchLanguage={switchLanguage}
        currentLang={currentLang}
        onOpenMenu={onOpenMenu}
        routes={filteredLinks}
      />
      <MobileMenu
        isOpen={isOpen}
        onClose={onClose}
        routes={ROUTES}
        isActiveRoute={isActiveRoute}
        switchLanguage={switchLanguage}
        currentLang={currentLang}
        excludeLinks={excludeLinks}
      />
    </>
  );
};

export default Menu;
